import { EProvince, getEProvinceList } from '@if/core/types'
import * as yup from '@if/core/yup'

const baseAddressCivicNumber = yup.string().default('')
const baseAddressStreet = yup.string().default('')
const baseAddressCity = yup.string().nullable().default('')
const baseAddressPostalCode = yup.string().nullable().default('').validCanadianPostalCode()
const baseAddressStateIso = yup
  .mixed<EProvince>()
  .nullable()
  .transform((value: string | null) => {
    return value === '' ? null : value
  })
  .default(null)
  .oneOf(getEProvinceList())
const baseAddressCountry = yup.string().nullable().default('Canada')

const fullAddressCivicNumber = baseAddressCivicNumber.required()
const fullAddressStreet = baseAddressStreet.required()
const fullAddressCity = baseAddressCity.required()
const fullAddressPostalCode = baseAddressPostalCode.required()
const fullAddressStateIso = baseAddressStateIso.required()
const fullAddressCountry = baseAddressCountry.required()

export const BaseAddressSchema = yup.object().shape({
  civicNumber: baseAddressCivicNumber,
  street: baseAddressStreet,
  apartment: yup.string().nullable(),
  suite: yup.string().nullable(),
  city: baseAddressCity,
  postalCode: baseAddressPostalCode,
  country: baseAddressCountry,
  stateIso: baseAddressStateIso,
  note: yup.string().nullable().default(''),
  years: yup.integer().min(0).notRequired().nullable().default(null),
  months: yup.integer().min(0).notRequired().nullable().default(null),
})

export type BaseAddress = yup.InferType<typeof BaseAddressSchema>

export const AddressSchema = BaseAddressSchema.when((v, schema) => {
  const value = v[0] as BaseAddress
  if (value?.civicNumber || value?.apartment || value?.suite || value?.street || value?.city || value?.postalCode) {
    return schema.shape({
      civicNumber: fullAddressCivicNumber,
      street: fullAddressStreet,
      city: fullAddressCity,
      postalCode: fullAddressPostalCode,
      stateIso: fullAddressStateIso,
    })
  }
  return schema
})

export type Address = yup.InferType<typeof AddressSchema>

export const FullAddressSchema = BaseAddressSchema.shape({
  civicNumber: fullAddressCivicNumber,
  street: fullAddressStreet,
  city: fullAddressCity,
  postalCode: fullAddressPostalCode,
  stateIso: fullAddressStateIso,
  country: fullAddressCountry,
})

export type FullAddress = yup.InferType<typeof FullAddressSchema>
